export default {
  namespaced: true,
  state: {
    hasUserClosedSlideOut: false,
    isSlideOutVisible: false,
    sidebarCloseTimeout: null
  },

  mutations: {
    CLOSE_SLIDEOUT (state) {
      state.isSlideOutVisible = false
      state.hasUserClosedSlideOut = true
    },

    OPEN_SLIDEOUT (state) {
      state.isSlideOutVisible = true
      state.hasUserClosedSlideOut = false
    },

    SET_SIDEBAR_CLOSE_TIMEOUT (state, timeout) {
      state.sidebarCloseTimeout = timeout
    },

    CLEAR_SIDEBAR_CLOSE_TIMEOUT (state) {
      clearTimeout(state.sidebarCloseTimeout)
    }
  },

  getters: {
    activeSidebar (state, getters, rootState, rootGetters) {
      const routeName = rootState.route.name
      const pathway = rootState.route.params.pathway

      if (routeName === 'page' && rootGetters.activePage) {
        return {
          description: rootGetters.activePage.description['en'],
          filterType: '',
          heading: rootGetters.activePage.heading['en'],
          markerGuide: false,
          minimap: rootGetters.activePage.minimapImage,
          qrMessage: rootGetters.activePage.qrMessage,
          qrUrl: rootGetters.activePage.qrUrl,
          virtualTourUrl: rootGetters.activePage.virtualTourUrl,
          virtualTourButtonLabel: rootGetters.activePage.virtualTourButtonLabel,
          issuuEmbedUrl: rootGetters.activePage.issuuEmbedUrl,
        }
      }

      if (['live', 'living-option'].includes(routeName) && rootGetters.config) {        
        return {
          description: rootGetters.config.liveHereDescription['en'],
          filterType: pathway,
          heading: rootGetters.config.liveHereHeading['en'],
          markerGuide: false,
          minimap: rootGetters.config.liveHereSidebarMinimap,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: rootGetters['property/activeLivingOption'] ? rootGetters['property/activeLivingOption'].isFilterHidden : false,
        }
      }

      if (['living-entry'].includes(routeName) && rootGetters.config) {        
        return {
          description: rootGetters.config.liveHereDescription['en'],
          filterType: '',
          heading: rootGetters.config.liveHereHeading['en'],
          markerGuide: false,
          minimap: rootGetters.config.liveHereSidebarMinimap,
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['subsection', 'property'].includes(routeName) && rootGetters['property/activeSubsection']) {        
        return {
          description: rootGetters['property/activeSubsection'].description,
          filterType: pathway,
          heading: rootGetters['property/activeSubsection'].label,
          markerGuide: rootGetters['property/activeSubsection'].properties.length ? true : false,
          minimap: rootGetters['property/activeSubsection'].minimapImage,
          qrMessage: '',
          qrUrl: '',
          isFilterHidden: rootGetters['property/activeSubsection'].isFilterHidden,
        }
      }

      if (['packages', 'package-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHerePackagesSidebarDesc['en'],
          filterType: 'package',
          heading: rootGetters.config.liveHerePackagesSidebarHeading['en'],
          markerGuide: false,
          minimap: '',
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['dwellings', 'dwelling-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHerePackagesSidebarDesc['en'],
          filterType: 'dwelling',
          heading: rootGetters.config.liveHerePackagesSidebarHeading['en'],
          markerGuide: false,
          minimap: '',
          qrMessage: '',
          qrUrl: '',
        }
      }

      if (['favourites', 'favourite-modal'].includes(routeName) && rootGetters.config) {
        return {
          description: rootGetters.config.liveHereFavouritesSidebarDesc['en'],
          filterType: '',
          heading: rootGetters.config.liveHereFavouritesSidebarHeading['en'],
          markerGuide: false,
          minimap: '',
          qrMessage: '',
          qrUrl: rootGetters['favourites/qrcode'],
        }
      }

      return {}
    },
    
    isSlideOutVisible (state) {
      return state.isSlideOutVisible
    },

    shouldSlideOutAutoOpen (state) {
      return !state.hasUserClosedSlideOut && !state.isSlideOutVisible
    }
  }
}
